/* eslint-disable */

export const getOneOrderConstants = {
    GET_ONE_ORDER_REQUEST: 'GET_ONE_ORDER_REQUEST',
    GET_ONE_ORDER_SUCCESS: 'GET_ONE_ORDER_SUCCESS',
    GET_ONE_ORDER_FAILURE: 'GET_ONE_ORDER_FAILURE',
};
